import MyCompanionAdd from './MyCompanionAdd';

function MyCompanionAddLanding({
  tableInfo,
}) {

  return (
    <div>
      <MyCompanionAdd typeId={tableInfo?.evento} />
    </div>
  );
}

export default MyCompanionAddLanding;
